import {ChangeDetectorRef, Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Directive({
  selector: '[tabValid]'
})
export class TabValidDirective implements OnChanges, OnInit{

  text:string = null;

  @Input()
  displayTabValidation: boolean;

  @Input()
  tabValid: boolean;

  constructor(private el: ElementRef) {
  }

  ngOnInit(){
    this.setValidationLogo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setValidationLogo();
  }

  setValidationLogo(){
    if (!this.text) {
      this.text = (<HTMLElement>this.el.nativeElement).innerHTML;
    }
    if(this.displayTabValidation) {
      if (this.tabValid) {
        (<HTMLElement>this.el.nativeElement).innerHTML = `<span style="color: green" class="fas fa-check"></span> ${this.text}`
      } else {
        (<HTMLElement>this.el.nativeElement).innerHTML = `<span style="color: red" class="fas fa-times"></span> ${this.text}`
      }
    }else{
      (<HTMLElement>this.el.nativeElement).innerHTML = this.text;
    }
  }
}
